import { Components, Theme } from "@mui/material";

declare module "@mui/material/Card" {}

export const MuiCard: Components<Theme>["MuiCard"] = {
  variants: [
    {
      props: { variant: "AbsenceBalanceStatus" },
      style: ({ theme }) => {
        const { palette } = theme;

        return {
          backgroundColor: palette.grey[100],
          padding: "0.5rem 1rem",
          borderRadius: "4px",
        };
      },
    },
  ],
};
